import { Panel, PanelType, Pivot, PivotItem, TooltipHost } from "office-ui-fabric-react";
import * as React from "react";
import RoomBookingSearch from "./RoomBookingSearch";
import SiteLocRoomList from "./SiteLocRoomList";

export interface IRoomBookingTopProps {
    onDismiss: () => void
}

export const RoomBookingTop = (props: IRoomBookingTopProps) => {
    return (
        <Panel type={PanelType.custom} customWidth="900px" isOpen={true} headerText="Room Availability" onDismiss={props.onDismiss} layerProps={{eventBubblingEnabled: true}}>
            <Pivot>
                <PivotItem 
                    onRenderItemLink={(pivotItemProps, defaultRender) => (
                        <TooltipHost content="Choose this option when you need a room for a particular date and time">
                            { defaultRender !== undefined && defaultRender(pivotItemProps) }
                        </TooltipHost>
                    )} 
                    headerText="Find room by date/time"
                >
                    <RoomBookingSearch /> 
                </PivotItem>
                <PivotItem 
                    onRenderItemLink={(pivotItemProps, defaultRender) => (
                        <TooltipHost content="Choose this option to view room calendars, and find availability for a particular room">
                            { defaultRender !== undefined && defaultRender(pivotItemProps) }
                        </TooltipHost>
                    )} 
                    headerText="Specific room availability"
                >
                    <SiteLocRoomList />
                </PivotItem>
            </Pivot>
        </Panel>
    );
};